/**
 * Frontend runtime configuration. All values come from Vite env vars
 * (prefixed VITE_) so they can be set per-environment at build time.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export const TOKEN_STORAGE_KEY = 'token';
export const USER_STORAGE_KEY = 'user';

// Map basemap tiles (Leaflet). Defaults to OpenStreetMap's standard tiles, which need
// no API key. To use a keyed provider, set VITE_MAP_TILE_URL (include the key in the
// URL) and VITE_MAP_TILE_ATTRIBUTION, and allow its host in the API's MAP_TILE_ORIGINS.
export const MAP_TILES = {
  url: import.meta.env.VITE_MAP_TILE_URL || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  options: {
    attribution:
      import.meta.env.VITE_MAP_TILE_ATTRIBUTION ||
      '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors',
    maxZoom: 19,
    // The API sends `Referrer-Policy: no-referrer` for the app's own pages, but public tile servers
    // (OpenStreetMap's usage policy) refuse browser requests that do not say which site they come from.
    referrerPolicy: 'strict-origin-when-cross-origin',
  },
};

// Hosts a charger's QR sticker may point at (first check in the browser; the API verifies the signature).
// The site's own host is always accepted, so a deployment needs no extra setting.
export const QR_ALLOWED_HOSTS = [
  ...(import.meta.env.VITE_QR_ALLOWED_HOST || 'chargeos.ph').split(',').map((h) => h.trim().toLowerCase()).filter(Boolean),
  ...(typeof window === 'undefined' ? [] : [window.location.hostname.toLowerCase()]),
];

/** Returns null for a well-formed charger QR address, otherwise the reason it is not one. */
export function chargerQrProblem(payload) {
  let url;
  try {
    url = new URL(String(payload || '').trim());
  } catch {
    return 'Malformed QR payload';
  }
  if (url.protocol !== 'https:' || !QR_ALLOWED_HOSTS.includes(url.hostname.toLowerCase())) return 'QR code does not point to the authorized ChargeOS domain';
  if (!/^\/c\/[^/]+\/\d+$/.test(url.pathname) || !url.searchParams.get('s') || !url.searchParams.get('n')) return 'QR code is missing its signature';
  return null;
}
